import { Cell } from "react-table";
import { CommonFacilityModel } from "src/api/building/building-types";
import { BaseButton, BaseTooltip } from "src/components";
import { floorOptions, Modal, SelectOption, spaceStyleOptions } from "src/pages/building/building-types";
import Esl from "../components/Esl";
import FacilityTagChips from "../components/FacilityTagChips";

const createFacilityColumns = (type: "MEETING_ROOM" | "REFRESH_ROOM"): Array<any> => {
  const facilityLabel = type === "MEETING_ROOM" ? "회의실" : "편의시설";

  return [
    {
      Header: "공용공간 ID",
      accessor: "id",
      width: 100,
      Cell: ({
        row,
        value,
        tableFunction,
      }: Cell<CommonFacilityModel> & {
        tableFunction: {
          openFacilityModal: (facility: { data: CommonFacilityModel; readonly: boolean }) => void;
          setConfirmModal: (modal: Modal) => void;
        };
      }) => {
        const { openFacilityModal } = tableFunction || {};
        return (
          <div
            className="text-underline "
            style={{ cursor: "pointer", color: "#007df0" }} //
            onClick={() => {
              openFacilityModal?.({ data: row?.original, readonly: true });
            }}
          >
            <BaseTooltip contents={value} isSingleLine={true} />
          </div>
        );
      },
    },
    {
      Header: "위치",
      accessor: "floorNum",

      width: 120,
      Cell: ({ row }: Cell<CommonFacilityModel>) => {
        const isGround = row?.original?.isGround; // 지상여부
        const floorNum = row?.original?.floorNum; // 위치
        const floor = floorOptions.find((option: SelectOption) => option.value === `${isGround ? "" : "-"}${floorNum}`);
        return floor?.label || "";
      },
    },
    {
      Header: `${facilityLabel} 명`,
      accessor: "facilityName",

      width: 240,
      Cell: ({ value }: any) => {
        return <BaseTooltip contents={value} className="w-100 text-left" />;
      },
    },
    {
      Header: `${facilityLabel} 유형`,
      accessor: "spaceStyle",

      width: 120,
      Cell: ({ value }: any) => {
        const findOption = spaceStyleOptions.find((option: SelectOption) => option.value === value);
        if (findOption && findOption.value !== "SPACE_STYLE_UNRECOGNIZED") {
          return <BaseTooltip contents={findOption.label} />;
        }
        return "";
      },
    },
    {
      Header: "Location code",
      accessor: "locationCode",

      width: 160,
      Cell: ({ value }: any) => {
        return <BaseTooltip contents={value} className="w-100 text-left" />;
      },
    },
    {
      Header: "정원(명)",
      accessor: "facilityMaxPeopleNums",
      width: 80,
    },
    {
      Header: "태그",
      accessor: "facilityTagList",
      width: 240,
      Cell: ({ row, column }: Cell<CommonFacilityModel>) => {
        const tags = row?.original?.facilityTagList || [];
        const columnWidth = Number(column?.width);
        return tags.length > 0 ? <FacilityTagChips tags={tags} columnWidth={columnWidth} /> : <span>-</span>;
      },
    },
    {
      Header: "ESL",
      accessor: "eslAddress",
      width: 120,

      Cell: ({ row }: any) => <Esl row={row} />,
    },
    {
      Header: "이미지",
      accessor: "mediaList",
      width: 80,
      Cell: ({ row }: any) => {
        const imageCount = (row?.original?.mediaList || []).length;
        return <div>{imageCount}</div>;
      },
    },
    {
      Header: "수정",
      sticky: "right",
      accessor: "edit",
      width: 80,
      Cell: ({
        row,
        tableFunction,
      }: Cell<CommonFacilityModel> & {
        tableFunction: { openFacilityModal: (facility: { data: CommonFacilityModel; readonly: boolean }) => void };
      }) => (
        <BaseButton
          title="수정"
          className="color-white"
          onClick={() => {
            const { openFacilityModal } = tableFunction || {};
            openFacilityModal({ data: row?.original, readonly: false });
          }}
        />
      ),
    },
    {
      Header: "삭제",
      sticky: "right",
      accessor: "delete",
      width: 40,
      Cell: ({ row, tableFunction }: Cell<CommonFacilityModel> & { tableFunction: { setConfirmModal: (modal: Modal) => void } }) => {
        const { setConfirmModal } = tableFunction || {};
        return (
          <button
            className="base-trash-btn color-gray"
            onClick={(e) => {
              e.preventDefault();
              console.log("여기냐");
              setConfirmModal({ isOpen: true, title: "삭제 하시겠습니까?", type: "FACILITY_DELETE", payload: row?.original.id });
            }}
          ></button>
        );
      },
    },
  ];
};

export const meetingRoomColumns = createFacilityColumns("MEETING_ROOM");
export const refreshRoomColumns = createFacilityColumns("REFRESH_ROOM");
